import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rtc-stats" }
const _hoisted_2 = { class: "stats-overview" }
const _hoisted_3 = { class: "stat-content" }
const _hoisted_4 = { class: "stat-icon online" }
const _hoisted_5 = { class: "stat-info" }
const _hoisted_6 = { class: "stat-number" }
const _hoisted_7 = { class: "stat-content" }
const _hoisted_8 = { class: "stat-icon call" }
const _hoisted_9 = { class: "stat-info" }
const _hoisted_10 = { class: "stat-number" }
const _hoisted_11 = { class: "stat-content" }
const _hoisted_12 = { class: "stat-icon quality" }
const _hoisted_13 = { class: "stat-info" }
const _hoisted_14 = { class: "stat-number" }
const _hoisted_15 = { class: "stat-content" }
const _hoisted_16 = { class: "stat-icon latency" }
const _hoisted_17 = { class: "stat-info" }
const _hoisted_18 = { class: "stat-number" }
const _hoisted_19 = { class: "detailed-stats" }
const _hoisted_20 = { class: "card-header" }
const _hoisted_21 = { class: "chart-container" }
const _hoisted_22 = { class: "chart-placeholder" }
const _hoisted_23 = { class: "chart-container" }
const _hoisted_24 = { class: "chart-placeholder" }
const _hoisted_25 = { class: "connection-list" }
const _hoisted_26 = { class: "card-header" }
const _hoisted_27 = { class: "header-actions" }
const _hoisted_28 = { class: "action-buttons" }
const _hoisted_29 = {
  key: 0,
  class: "connection-details"
}
const _hoisted_30 = { class: "detail-charts" }
const _hoisted_31 = { class: "chart-placeholder" }

import { ref, reactive, onMounted, computed } from "vue";
import {
  Refresh,
  Search,
  View,
  Connection,
  Phone,
  TrendCharts,
  Timer,
  PieChart,
} from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";

// 中文注释：引入全局store

export default /*@__PURE__*/_defineComponent({
  __name: 'RTCStats',
  setup(__props) {

const store = useStore();

// 权限检查函数
const hasPermission = (perm: string) => store.getters.hasPermission(perm);

// 响应式数据
const loading = ref(false);
const detailDialogVisible = ref(false);
const currentConnection = ref(null);
const searchKeyword = ref("");
const qualityTimeRange = ref("1h");

// 统计概览数据
const statsOverview = reactive({
  activeConnections: 5,
  totalCalls: 128,
  avgQuality: 95,
  avgLatency: 45,
});

// 连接列表数据
const connections = ref([
  {
    device_id: "d83bda4d33b8",
    connection_id: "conn_001",
    status: "connected",
    quality: 98,
    latency: 32,
    packet_loss: 0.1,
    connected_at: "2024-01-15 10:30:00",
    bandwidth: 128,
  },
  {
    device_id: "d83bda4d33b9",
    connection_id: "conn_002",
    status: "connecting",
    quality: 85,
    latency: 65,
    packet_loss: 2.3,
    connected_at: "2024-01-15 10:25:00",
    bandwidth: 96,
  },
]);

// 过滤后的连接列表
const filteredConnections = computed(() => {
  if (!searchKeyword.value) {
    return connections.value;
  }
  return connections.value.filter((conn) =>
    conn.device_id.toLowerCase().includes(searchKeyword.value.toLowerCase())
  );
});

// 获取RTC统计数据
const fetchRTCStats = async () => {
  loading.value = true;
  try {
    // TODO: 调用真实API
    console.log("[真实接口] 获取RTC统计数据");
    // const response = await apiClient.get("/rtc/stats");
    // statsOverview.activeConnections = response.data.active_connections;
    // statsOverview.totalCalls = response.data.total_calls;
    // statsOverview.avgQuality = response.data.avg_quality;
    // statsOverview.avgLatency = response.data.avg_latency;
  } catch (error) {
    console.error("获取RTC统计数据失败:", error);
    ElMessage.error("获取RTC统计数据失败");
  } finally {
    loading.value = false;
  }
};

// 获取连接列表
const fetchConnections = async () => {
  loading.value = true;
  try {
    // TODO: 调用真实API
    console.log("[真实接口] 获取连接列表");
    // const response = await apiClient.get("/rtc/connections");
    // connections.value = response.data;
  } catch (error) {
    console.error("获取连接列表失败:", error);
    ElMessage.error("获取连接列表失败");
  } finally {
    loading.value = false;
  }
};

// 刷新统计数据
const refreshStats = () => {
  fetchRTCStats();
  fetchConnections();
};

// 查看连接详情
const viewConnectionDetails = (connection: any) => {
  currentConnection.value = connection;
  detailDialogVisible.value = true;
};

// 关闭详情对话框
const closeDetailDialog = () => {
  detailDialogVisible.value = false;
  currentConnection.value = null;
};

// 获取连接状态类型
const getConnectionStatusType = (status: string) => {
  const statusMap: Record<string, string> = {
    connected: "success",
    connecting: "warning",
    disconnected: "danger",
    error: "danger",
  };
  return statusMap[status] || "info";
};

// 获取连接状态文本
const getConnectionStatusText = (status: string) => {
  const statusMap: Record<string, string> = {
    connected: "已连接",
    connecting: "连接中",
    disconnected: "已断开",
    error: "错误",
  };
  return statusMap[status] || status;
};

// 获取质量颜色
const getQualityColor = (quality: number) => {
  if (quality >= 90) return "#67C23A";
  if (quality >= 70) return "#E6A23C";
  return "#F56C6C";
};

// 页面加载时获取数据
onMounted(() => {
  fetchRTCStats();
  fetchConnections();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "stat-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Connection))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(statsOverview.activeConnections), 1),
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-label" }, "活跃连接", -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "stat-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Phone))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(statsOverview.totalCalls), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "stat-label" }, "总通话数", -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "stat-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TrendCharts))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(statsOverview.avgQuality) + "%", 1),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "stat-label" }, "平均质量", -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "stat-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Timer))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(statsOverview.avgLatency) + "ms", 1),
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "stat-label" }, "平均延迟", -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "chart-card" }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", null, "连接质量趋势", -1)),
                    _createVNode(_component_el_select, {
                      modelValue: qualityTimeRange.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((qualityTimeRange).value = $event)),
                      style: {"width":"120px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "最近1小时",
                          value: "1h"
                        }),
                        _createVNode(_component_el_option, {
                          label: "最近24小时",
                          value: "24h"
                        }),
                        _createVNode(_component_el_option, {
                          label: "最近7天",
                          value: "7d"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TrendCharts))
                        ]),
                        _: 1
                      }),
                      _cache[8] || (_cache[8] = _createElementVNode("p", null, "连接质量趋势图表", -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("small", null, "显示最近时间段的连接质量变化", -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "chart-card" }, {
                header: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("span", null, "设备连接状态")
                  ], -1)
                ]))]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PieChart))
                        ]),
                        _: 1
                      }),
                      _cache[11] || (_cache[11] = _createElementVNode("p", null, "设备连接状态分布", -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("small", null, "显示在线、离线、通话中等状态的设备数量", -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_el_card, { class: "list-card" }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_26, [
            _cache[13] || (_cache[13] = _createElementVNode("span", null, "实时连接列表", -1)),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_input, {
                modelValue: searchKeyword.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchKeyword).value = $event)),
                placeholder: "搜索设备ID",
                style: {"width":"200px"},
                clearable: ""
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Search))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: filteredConnections.value,
            style: {"width":"100%"},
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "device_id",
                label: "设备ID",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "connection_id",
                label: "连接ID",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "status",
                label: "状态",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_tag, {
                    type: getConnectionStatusType(scope.row.status)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getConnectionStatusText(scope.row.status)), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "quality",
                label: "质量",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_progress, {
                    percentage: scope.row.quality,
                    color: getQualityColor(scope.row.quality),
                    "stroke-width": 8
                  }, null, 8, ["percentage", "color"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "latency",
                label: "延迟",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.latency) + "ms ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "packet_loss",
                label: "丢包率",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.packet_loss) + "% ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "connected_at",
                label: "连接时间",
                width: "160"
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "120",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (viewConnectionDetails(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(View))
                          ]),
                          _: 1
                        }),
                        _cache[14] || (_cache[14] = _createTextVNode(" 详情 ", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, loading.value]
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: detailDialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((detailDialogVisible).value = $event)),
      title: "连接详情",
      width: "800px",
      onClose: closeDetailDialog
    }, {
      default: _withCtx(() => [
        (currentConnection.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(_component_el_descriptions, {
                column: 2,
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "设备ID" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(currentConnection.value.device_id), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "连接ID" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(currentConnection.value.connection_id), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, {
                        type: getConnectionStatusType(currentConnection.value.status)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getConnectionStatusText(currentConnection.value.status)), 1)
                        ]),
                        _: 1
                      }, 8, ["type"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "连接时间" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(currentConnection.value.connected_at), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "质量" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_progress, {
                        percentage: currentConnection.value.quality,
                        color: getQualityColor(currentConnection.value.quality)
                      }, null, 8, ["percentage", "color"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "延迟" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(currentConnection.value.latency) + "ms ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "丢包率" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(currentConnection.value.packet_loss) + "% ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "带宽" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(currentConnection.value.bandwidth) + "kbps ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_30, [
                _cache[16] || (_cache[16] = _createElementVNode("h4", null, "实时指标", -1)),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TrendCharts))
                    ]),
                    _: 1
                  }),
                  _cache[15] || (_cache[15] = _createElementVNode("p", null, "实时质量、延迟、丢包率趋势图", -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})